import { ArrowLeft } from 'lucide-react';
import React from 'react';

import { ViewMode } from '@repo/ui/state';
import { Button } from '../../../ui/button';
import { HeaderProps } from '../types';
import { HeaderActionButtons } from './action-buttons';

export const Header: React.FC<HeaderProps> = ({
  backButtonTitle,
  isDismissedStage,
  viewMode,
  loading,
  error,
  onBackButtonClick,
  onDismissedFolderClick,
  onNewStageClick,
  dismissedCount,
  canCreateStage,
}) => {
  return (
    <header className="flex justify-between items-center bg-transparent">
      <Button
        className="flex items-center px-0 gap-2"
        variant="link"
        onClick={onBackButtonClick}
        data-testid="back-button"
        disabled={viewMode === ViewMode.SELECT}
      >
        <ArrowLeft />
        <span className="text-sm font-normal leading-5 text-foreground">
          {backButtonTitle}
        </span>
      </Button>
      {isDismissedStage ? (
        <div className="flex md:hidden items-center text-zinc-500 text-sm pl-1 h-12">
          Dismissed Folder {dismissedCount}
        </div>
      ) : (
        <HeaderActionButtons
          viewMode={viewMode}
          loading={loading}
          error={error}
          dismissedCount={dismissedCount}
          onDismissedFolderClick={onDismissedFolderClick}
          onNewStageClick={onNewStageClick}
          canCreateStage={canCreateStage}
        />
      )}
    </header>
  );
};
